import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { IconLock } from '@tabler/icons-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
  /** スタンプ/ポイントラベル（例: "スタンプ" / "ポイント" / "スタンプ・ポイント"）。未指定時は "スタンプ" */
  stampLabel?: string
}

/**
 * ARフォトフレームがスタンプ未取得のためロックされている状態を表示するダイアログ。
 * スタンプ獲得前に AR フォトボタンをタップした場合に表示する。
 * Figma node: 551:17760
 */
export const DialogArPhotoLocked = memo(({ onClose, scrollLock = false, stampLabel = 'スタンプ' }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={true} compact showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <div className="flex flex-col items-center gap-[16px] py-[8px]">
        <div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#f5f5f5]">
          <IconLock size={32} className="text-[#757575]" />
        </div>

        <p className="text-center text-[14px] font-bold text-black leading-[22px]">
          {t('spot_detail.ar_photo.locked_message', 'ARフォトフレームは\n{{what}}獲得後に\nご利用いただけます', {
            what: stampLabel,
          })}
        </p>

        <Button
          label={t('common.close', '閉じる')}
          variant="system"
          size="sm"
          round
          onClick={onClose}
          className="!w-[254px]"
        />
      </div>
    </Dialog>
  )
})
